import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

// Pass the names without the currently edited item.
// Default is case-insensitive (roles: backend compares NormalizedName); pass caseSensitive = true
// where the backend compares the raw name (e.g. TimeEntryCategoryByNameSpec on Postgres).
export function UniqueNameValidator(existingNames: () => string[], caseSensitive = false): ValidatorFn {
    const normalize = (name: string) => caseSensitive ? name?.trim() : name?.trim().toUpperCase();
    return (control: AbstractControl): ValidationErrors | null => {
      const value = normalize(control.value);
      if (!value) {
        return null;
      }
      const exists = existingNames().some(name => normalize(name) === value);
      return exists ? {isNotUnique: true} : null;
    };
  }
